module.exports = __webpack_public_path__ + "img/ai_recycle_02.71cca7be.png";